// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1cPzx","label":"Radio_label__6unNK","checkMark":"Radio_checkMark__3io0V","disabled":"Radio_disabled__1OR1T"};